import * as React from 'react'
import Banner from "@/components/banner"
import StickyHeader from './sticky-banner'
import ToolBar from './toolbar'
import AudioBar from './audio-bar'

const Layout = ({ children }) => {
    return (
        <>
            <Banner />
            <StickyHeader />
            <div className='relative font-light'>
                <ToolBar />
                <main>
                    <div id="anchor-top" />
                    {children}
                </main>
                <AudioBar />            
            </div>
        </>
    )
}

export default Layout
